/**
 * Weather Animations
 * 
 * This function could be adapted to use snow,
 * rain, or other kinds of weather animations.
 * 
 * Original Author: DIACO : twitter.com/Diaco_ml  ||  codepen.io/MAW
 */
import { gsap } from "gsap";
import { GSDevTools } from "gsap/GSDevTools";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";



export default function initWeather() {
    /**
     * Snowfall Animation
     */
    function stormSnow() {
        var total = 50;
        var warp = document.getElementById("storm-snow");
        var i = 0;

        // Create snow flakes
        for (i = 0; i < total; i++) {
            var Div = document.createElement('div');
            gsap.set(Div, { attr: { class: 'snowflake' }, x: R(0, 200), y: R(0, 0), z: R(0, 0) });
            warp.appendChild(Div);
            animm(Div);
        }

        // Animate the snow flakes
        function animm(elm) {
            gsap.to(elm, { y: 250, ease: "none", repeat: -1, delay: -15, duration: R(3, 6.5) });
            gsap.to(elm, { x: '+=45', repeat: -1, yoyo: true, ease: "sine.inOut", duration: R(5, 7) });
        };

        // Random durations for slow and fast snow flakes
        function R(min, max) { return min + Math.random() * (max - min) };
    }



    /**
     * Animate clouds
     */
    function clouds() {
        var cloudstl = gsap.timeline();

        cloudstl.from(".cloud-1", { duration: 2, opacity: 0, y: -16, scale: .5, ease: "power3.inOut" }, "in")
            .from(".cloud-2", { duration: 2, opacity: 0, x: -16, scale: .5, ease: "power3.inOut" }, "in")
            .from(".cloud-3", { duration: 2, opacity: 0, x: -16, y: -16, scale: .5, ease: "power3.inOut" }, "in")
            .from(".cloud-4", { duration: 2, opacity: 0, y: 16, scale: .5, ease: "power3.inOut" }, "in")
            .from(".cloud-5", { duration: 2, opacity: 0, x: 8, y: -16, scale: .5, ease: "power3.inOut" }, "in")
            .from(".cloud-6", { duration: 2, opacity: 0, x: -1, scale: .5, ease: "power3.inOut" }, "in")
            .to(".cloud-1", { duration: 3, y: 10, x: 4, yoyo: true, ease: "power1.inOut", repeat: -1 }, "clouds")
            .to(".cloud-2", { duration: 3, y: 4, x: 8, yoyo: true, ease: "power1.inOut", delay: .25, repeat: -1 }, "clouds")
            .to(".cloud-3", { duration: 3, y: 8, x: 8, yoyo: true, ease: "power1.inOut", delay: .5, repeat: -1 }, "clouds")
            .to(".cloud-4", { duration: 3, y: 12, x: 8, yoyo: true, ease: "power1.inOut", delay: .08, repeat: -1 }, "clouds")
            .to(".cloud-5", { duration: 3, y: 6, x: 6, yoyo: true, ease: "power1.inOut", delay: 1, repeat: -1 }, "clouds")
            .to(".cloud-6", { duration: 3, y: 8, x: -8, yoyo: true, ease: "power1.inOut", delay: .15, repeat: -1 }, "clouds")
            .to("#storm-snow", { duration: 1.5, opacity: 1 }, "clouds-=.25");

        return cloudstl;
    }
    var cloudstltlm = gsap.timeline({ repeat: -1 });



    /**
     * Activate storms
     */
    if (document.querySelector(['#storm-snow-animation'])) {
        stormSnow();
        cloudstltlm.add(clouds());
    }
}